module.exports = __webpack_public_path__ + "carousel-grey-1.388b2ca553f21d3f0b0b6b725902dd0a.jpg";